import type { Node } from "@craftjs/core";
import { useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";

import useViewport from "@/hooks/use-viewport";
import getViewportValue from "@/utils/get-viewport-value";

type Props = {
  children: React.ReactNode;
};

export default function VideoWithParagraphList(props: Props) {
  const {
    connectors: { connect },
  } = useNode();

  const viewport = useViewport();

  const style: React.CSSProperties = React.useMemo(() => {
    return {
      display: "grid",
      alignItems: "center",
      gridTemplateColumns: getViewportValue(
        ["auto", "1fr 1fr", "1fr 1fr"],
        viewport
      ),
      gridGap: rem(24),
    };
  }, [viewport]);

  return (
    <div ref={connect} style={style}>
      {props.children}
    </div>
  );
}

const isNodeAllowed = (type) => ["Video", "ParagraphItem"].includes(type);
VideoWithParagraphList.craft = {
  rules: {
    canMoveIn: (nodes: Node[]) => {
      const nodeTypes = nodes?.map((node) => node?.type);
      return nodeTypes.length > 0 && nodeTypes.every(isNodeAllowed);
    },
  },
};
